import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsBoost from 'highcharts/modules/boost';
import { INegativeColumnGraph } from '../../../interfaces/charts/trader-advisor.interface';

@Component({
	selector: 'traderadvisor-column-negative',
	templateUrl: './traderadvisor-column-negative.component.html',
	styleUrls: ['./traderadvisor-column-negative.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class TraderadvisorNegativeColumnComponent implements OnInit {
	@Input() public options: INegativeColumnGraph;
	public normalGain: string ='#00E8BE';
	public normalLoss: string = '#FF8990';
	public outlierGain: string = '#00C898';
	public outlierLoss: string = '#F02733';

	constructor() {
		HighchartsBoost(Highcharts);
		HighchartsMore(Highcharts);
	}

	ngOnInit() {
		try {
            if(this.options) {
				//this.overrideToLogrithmic();
                Highcharts.chart('hc-negative-column', {
					chart: {
						type: 'column',
						height: '300',
					},
					title: {
						text: '',
					},
					lang: {
						noData: 'Sem dados para exibir'
					},
					yAxis: {
						title: {
							text: '',
							offset: 0,
						},
						labels: {
							format: 'R$ {value:,.0f}'
						},
						plotLines: [{
							color: '#00E8BE',
							dashStyle: 'Dash',
							width: 1,
							value: this.options.medianLine.gain,
							zIndex: 3
						},{
							color: '#FB4E82',
							dashStyle: 'Dash',
							width: 1,
							value: this.options.medianLine.loss,
							zIndex: 3
						}],
						plotBands: [{
							from: this.options.medianBands.loss.from,
							to: this.options.medianBands.loss.to,
							color: '#FFEFF4',
						},{
							from: this.options.medianBands.gain.from,
							to: this.options.medianBands.gain.to,
							color: '#EBFEFA',
						}]
					},
					xAxis: {
						type: 'datetime',
						labels: {
							formatter: function() {
								return Highcharts.dateFormat('%e/%m', +this.value);
							}
						},
						categories: this.options.data.dates,
					},
					tooltip: {
						formatter: function(){
							return 'R$ ' + Highcharts.numberFormat(this.y,2,',','.');
						}
					},
					series: [{
						type: "column",
						maxPointWidth: 50,
						showInLegend: false,
						data: this.colorizeBars(this.options.data.results),
						}]
				});
            }
        } catch (error) {
            throw error;
        }
	}

	// public overrideToLogrithmic() {
	// 	(function (H) {
	// 		// Pass error messages
	// 		H.Axis.prototype.allowNegativeLog = true;
		
	// 		// Override conversions
	// 		H.Axis.prototype.log2lin = function (num) {
	// 			var isNegative = num < 0,
	// 				adjustedNum = Math.abs(num),
	// 				result;
	// 			if (adjustedNum < 10) {
	// 				adjustedNum += (10 - adjustedNum) / 10;
	// 			}
	// 			result = Math.log(adjustedNum) / Math.LN10;
	// 			return isNegative ? -result : result;
	// 		};
	// 		H.Axis.prototype.lin2log = function (num) {
	// 			var isNegative = num < 0,
	// 				absNum = Math.abs(num),
	// 				result = Math.pow(10, absNum);
	// 			if (result < 10) {
	// 				result = (10 * (result - 1)) / (10 - 1);
	// 			}
	// 			return isNegative ? -result : result;
	// 		};
	// 	}(Highcharts));
	// }

	public colorizeBars(data: number[]) {
		return data.map((value) => {
			if(value >= this.options.medianBands.gain.from && value <= this.options.medianBands.gain.to) {
				return {y: value, color: this.normalGain}
			}
			if(value <= this.options.medianBands.loss.from && value >= this.options.medianBands.loss.to) {
				return {y: value, color: this.normalLoss}
			}
			if(value > 0) {
				return {y: value, color: this.outlierGain}
			}
			if(value < 0) {
				return {y: value, color: this.outlierLoss}
			}
		})
	}
}
